<template>
  <div>
    <el-drawer
      :visible.sync="drawerVisible"
      :with-header="false"
      direction="rtl"
      size="1000px">
      <div class="base-padding__all-20 detail-content">
        <el-tabs v-model="activeName" class="detail-tabs">
          <el-tab-pane :label="$t('multiCloudCluster.instanceDetails.instanceDetails')"
                       name="details">
            <details-info :instance-details="instanceDetails"></details-info>
          </el-tab-pane>
          <el-tab-pane :label="$t('multiCloudCluster.instanceDetails.instanceMonitor')"
                       name="monitor">
            <Monitor v-if="activeName === 'monitor'"
                     :multiCloudPartitionInstanceId="instanceDetails.multiCloudPartitionInstanceId"></Monitor>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import DetailsInfo from './detailsInfo/Index.vue';
import Monitor from '../monitor/echartsBox.vue';

export default {
  name: 'InstanceDetails',
  props: {},
  components: {
    DetailsInfo,
    Monitor,
  },
  data() {
    return {
      drawerVisible: false,
      drawerTitle: '',
      instanceDetails: {},
      activeName: 'details',
    };
  },

  mounted() {
    console.log('mounted');
  },

  methods: {
    // js函数

    /**
     * 打开实例详情抽屉
     * @param instanceInfo: 实例信息
     * */
    openInstanceDetailsDrawer(instanceInfo) {
      this.activeName = 'details';
      this.instanceDetails = instanceInfo;
      this.drawerVisible = true;
    },

  },
};
</script>
<style lang="scss" scoped>
.detail-content {
  height: calc(100% - 52px);

  .detail-tabs {
    height: 100%;

    ::v-deep .el-tabs__header {
      padding: 0 20px;
      background: #fff;
    }

    ::v-deep .el-tabs__content {
      height: 100%;

      .el-tab-pane {
        height: 100%;
      }
    }
  }
}
</style>
